import { DepositSchedule } from "@/modules/deposit/components";
import { PageHeader } from "@/shared/components";

export const DepositSchedulePage = () => {
  return (
    <div className="full-width page-container">
      <PageHeader/>
      <DepositSchedule/>
    </div>
  );
};
